<template>
    <template v-if="proveedorName === 'ANDREANI'">
        <img src="@assets/images/proveedores/andreani.svg" class="w-28 my-2" />
    </template>
    <template v-else-if="proveedorName === 'REAL EXPRESS'">
        <img
            src="@assets/images/proveedores/real_express.svg"
            class="w-28 my-2"
        />
    </template>
    <template v-else-if="proveedorName === 'MOOVA'">
        <img src="@assets/images/proveedores/moova.svg" class="w-28 my-2" />
    </template>
    <template v-else-if="proveedorName === 'JAVIT'">
        <img src="@assets/images/proveedores/javit.svg" class="w-24 my-2" />
    </template>
    <template v-else-if="proveedorName === 'SAIRES'">
        <img src="@assets/images/proveedores/saires.svg" class="w-28 my-2" />
    </template>
    <template v-else-if="proveedorName === 'MOCIS'">
        <img src="@assets/images/proveedores/mocis.svg" class="w-20 my-2" />
    </template>
    <template v-else-if="proveedorName === 'CEA'">
        <img src="@assets/images/proveedores/cea.svg" class="w-20 my-2" />
    </template>
    <template v-else-if="proveedorName === 'BRIO'">
        <img src="@assets/images/proveedores/brio.svg" class="w-20 my-2" />
    </template>
    <template v-else-if="proveedorName === 'CRUZ DEL SUR'">
        <img src="@assets/images/proveedores/cruzdelsur.svg" class="w-20 my-2" />
    </template>
    <template v-else-if="proveedorName === 'TEST SHIPRO'">
        <img src="@assets/images/proveedores/shipro.svg" class="w-20 my-2" />
    </template>
    <template else>
        <div class="my-2">{{ proveedorName }}</div>
    </template>
</template>

<script>
export default {
    name: "ProveedorLogo",
    props: {
        proveedor: String,
    },
    computed: {
        proveedorName() {
            return this.proveedor.toUpperCase();
        },
    },
};
</script>